import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import sessionRoutes from "./views/sessions/session-routes";
import { DropdownProvider } from "./contexts/DropdownContext"; // 👈 import here

// Lazy-loaded components
const JobTable = Loadable(
  lazy(() => import("./views/material-kit/tables/JobTable"))
);
const TaskTable = Loadable(
  lazy(() => import("./views/material-kit/tables/ViewTaskTable"))
);
const DocTable = Loadable(
  lazy(() => import("./views/material-kit/Documents/documentTable"))
);
const AddTask = Loadable(
  lazy(() => import("./views/material-kit/tables/createtask"))
);
const AppDialog = Loadable(
  lazy(() => import("./views/material-kit/Jobs/editjob"))
);
const UploadJobs = Loadable(
  lazy(() => import("./views/material-kit/Jobs/uploadjobs"))
);
const UserDetails = Loadable(
  lazy(() => import("./views/material-kit/UserDetails/UserDetails"))
);
const Roles = Loadable(
  lazy(() => import("./views/material-kit/UserDetails/rolemangements"))
);
const Dashboard1 = Loadable(lazy(() => import("./views/dashboard/dashboard")));
const RequestTable = Loadable(
  lazy(() => import("./views/material-kit/Requests/requesttable"))
);
const UpdateDocument = Loadable(
  lazy(() => import("app/views/material-kit/Documents/updatedocument"))
);
const Analytics = Loadable(
  lazy(() => import("app/views/material-kit/Documents/UploadDocument"))
);
const ExistUpdateDocument = Loadable(
  lazy(() => import("app/views/material-kit/Documents/existUpdateDoc"))
);
// const AppDialog1 = Loadable(
//   lazy(() => import("./views/material-kit/Jobs/overviewJob"))
// );

const ProjectOver = Loadable(
  lazy(() => import("./views/material-kit/reports/projectoverview"))
);
const UserEntries = Loadable(
  lazy(() => import("./views/material-kit/reports/userentries"))
);
const Dailystatus = Loadable(
  lazy(() => import("./views/material-kit/reports/dailystatus"))
);
const ProjVsRevMonth = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/projvsrevreport"))
);
const ProjVsAchMonth = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/projvsachreport"))
);
const DailyUserProd = Loadable(
  lazy(() =>
    import("./views/material-kit/reports/paulReports/daily_user_prod_report")
  )
);
const Inputs = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/inputsReport"))
);
const InputsSummery = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/inputssummery"))
);
const OutSatndingTask = Loadable(
  lazy(() =>
    import("./views/material-kit/reports/paulReports/outstandingReport")
  )
);
const Outputs = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/outputsreport"))
);
const Outputs1 = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/ouputreport-byworkdriver"))
);
const OutputsGraph = Loadable(
  lazy(() =>
    import("./views/material-kit/reports/paulReports/weekwiseoutputreport")
  )
);

const RequestReport = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/requestreport"))
);
const Admin = Loadable(
  lazy(() => import("./views/material-kit/Jobs/adminpage"))
);
const DeleteDocList = Loadable(
  lazy(() => import("./views/material-kit/Documents/deletedocuments"))
);
const QuriesTable = Loadable(
  lazy(() => import("./views/material-kit/tables/viewquries"))
);
const QuriesReport = Loadable(lazy(() => import("./views/material-kit/reports/queryreport")));
const EditRequest = Loadable(lazy(() => import("./views/material-kit/Requests/editRequest")));
const AddRequest = Loadable(lazy(() => import("./views/material-kit/Requests/addRequestPage")));
const OutReport = Loadable(
  lazy(() => import("./views/material-kit/reports/paulReports/outstandingwholereport"))
);

const TeamDailyStatus = Loadable(
  lazy(() => import("./views/material-kit/Jobs/teamDailySatus"))
);
// Protected route to check if JWT token exists
const ProtectedRoute = () => {
  const jwtToken = sessionStorage.getItem("userdata");
  return jwtToken ? <Outlet /> : <Navigate to="/session/signin" replace />;
};

// Material Kit Routes
const materialRoutes = [
  { path: "/viewjobs", element: <JobTable /> },
  { path: "/viewtasks", element: <TaskTable /> },
  { path: "/doctable", element: <DocTable /> },
  { path: "/createtask", element: <AddTask /> },
  { path: "/material/editjob", element: <AppDialog /> },
  { path: "/uploadjobs", element: <UploadJobs /> },
  { path: "/userdetails", element: <UserDetails /> },
  { path: "/roles", element: <Roles /> },
  { path: "/dashboard", element: <Dashboard1 /> },
  { path: "/requests", element: <RequestTable /> },
  { path: "/convertdoc", element: <Analytics /> },
  { path: "/updatedocument", element: <UpdateDocument /> },
  { path: "/existupdatedocument", element: <ExistUpdateDocument /> },
  // { path: "/material/overview", element: <AppDialog1 /> },
  { path: "/projectstatus", element: <ProjectOver /> },
  { path: "/userentries", element: <UserEntries /> },
  { path: "/dailystatus", element: <Dailystatus /> },
  { path: "/projvsrevreport", element: <ProjVsRevMonth /> },
  { path: "/projvsachreport", element: <ProjVsAchMonth /> },
  { path: "/dailyuserprodreport", element: <DailyUserProd /> },
  { path: "/inputsreport", element: <Inputs /> },
  { path: "/inputssummery", element: <InputsSummery /> },
  { path: "/outstandingtask", element: <OutSatndingTask /> },
  { path: "/outputsreport", element: <Outputs /> },
  { path: "/outputsreportgrapg", element: <OutputsGraph /> },
  { path: "/requestreport", element: <RequestReport /> },
  { path: "/admin", element: <Admin /> },
  { path: "/deletedocumets", element: <DeleteDocList /> },
  { path: "/queries", element: <QuriesTable /> },
  { path: "/queriesreport", element: <QuriesReport /> },
  { path: "/editrequest", element: <EditRequest /> },
  { path: "/addrequest", element: <AddRequest /> },
  { path: "/outstandsummery", element: <OutReport /> },
  { path: "/teamDailySatus", element: <TeamDailyStatus /> },
    { path: "/outputsreportworkdriver", element: <Outputs1 /> },



];

// Main routes configuration
// const routes = [
//   {
//     path: "/",
//     element: <Navigate to="session/signin" />,
//   },

//   {
//     element: <ProtectedRoute />,
//     children: [
//       {
//         element: <MatxLayout />,
//         children: materialRoutes,
//       },
//     ],
//   },
//   ...sessionRoutes,
// ];

const routes = [
  {
    path: "/",
    element: <Navigate to="session/signin" />,
  },

  {
    element: <ProtectedRoute />,
    children: [
      {
        // 👇 Wrap MatxLayout with DropdownProvider here
        element: (
          <DropdownProvider>
            <MatxLayout />
          </DropdownProvider>
        ),
        children: materialRoutes,
      },
    ],
  },
  ...sessionRoutes,
];
export default routes;
